export const goToStepStyles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter",
  },
  nodeInitial: {
    position: "relative",
    top: "20px",
    left: "10px",
    color: "#797b8c",
    textAlign: "center",
    paddingRight: "35px",
  },
  bottomRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    "&:hover": {
      cursor: "pointer",
    },
  },
  nodeBody: {
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: "30px",
    minWidth: "90px",
    fontSize: "16px",
    color: "#22304a",
    backgroundColor: "#ffdc66",
    borderRadius: "20px",
    marginBottom: "30px",
    boxShadow: "0 2px 15px rgba(0,0,0,.071)",
  },
  titleName: {
    fontSize: "12px",
    fontFamily: "Inter",
    fontWeight: 525,
  },
  iconButton: {
    height: "20px",
    width: "20px",
    marginLeft: "5px",
    marginRight: "4px",
    transform: "rotate(89deg)",
    "&:hover": {
      backgroundColor: "#ffdc66",
    },
  },
  nodeIcon: {
    fontSize: "19px",
    color: "#22304a",
    fontWeight: 600,
  },
  addIcon: {
    fontSize: "14px",
    height: "20px",
    width: "20px",
    color: "#22304a",
    borderRadius: "50%",
    backgroundColor: "white",
    marginLeft: "4px",
    transition: "visibility 0s, color 0.2s",
    position: "relative",
    bottom: "13px",
    "&:hover": {
      color: "blue",
    },
  },
  leftHandle: {
    background: "#566d89",
    opacity: "0",
    top: "-11px",
    position: "relative",
  },
  rightHandle: {
    background: "#566d89",
    opacity: "0",
    top: "3px",
    left: "13px",
    position: "relative",
  },
};
